import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=e8b4ab82"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=e8b4ab82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports